import React from 'react';
import { useIntl } from 'react-intl';
import { productSchema } from '../../utils/schema';

const ProductSchema = ({
  productInfo: { adult, campaign, name, shortDesc, EAN, brand, group_id, images, offers, expiredProduct },
  reviewsInfo,
}) => {
  const intl = useIntl();

  const firstOffer = offers?.length ? offers[0] : null;

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          ...productSchema(
            name,
            shortDesc,
            group_id,
            brand?.trim(),
            firstOffer?.EAN,
            images.slice(0, 4),
            reviewsInfo?.reviews,
            intl.formatMessage({ id: 'reviews.anonymous', defaultMessage: 'Anonymous' }),
            reviewsInfo?.rating,
            adult,
            offers,
            expiredProduct,
            campaign
          ),
        }),
      }}
    />
  );
};

export default ProductSchema;
